import * as React from 'react';

import { cn } from '@/lib/cn';

function SlimTable({ className, ...props }: React.ComponentProps<'table'>) {
  return (
    <div className="relative w-full">
      <table
        data-slot="slim-table"
        className={cn('w-full caption-bottom text-base', className)}
        {...props}
      />
    </div>
  );
}

function SlimTableHeader({
  className,
  ...props
}: React.ComponentProps<'thead'>) {
  return (
    <thead
      data-slot="slim-table-header"
      className={cn('border-b-0', className)}
      {...props}
    />
  );
}

function SlimTableBody({ className, ...props }: React.ComponentProps<'tbody'>) {
  return (
    <tbody
      data-slot="slim-table-body"
      className={cn('', className)}
      {...props}
    />
  );
}

function SlimTableRow({ className, ...props }: React.ComponentProps<'tr'>) {
  return (
    <tr
      data-slot="slim-table-row"
      className={cn('border-b-0', className)}
      {...props}
    />
  );
}

function SlimTableHead({ className, ...props }: React.ComponentProps<'th'>) {
  return (
    <th
      data-slot="slim-table-head"
      className={cn(
        'px-0 pr-1.25 pb-6.25 text-left align-middle text-base font-semibold [&:has([role=checkbox])]:pr-0',
        className,
      )}
      {...props}
    />
  );
}

function SlimTableCell({ className, ...props }: React.ComponentProps<'td'>) {
  return (
    <td
      data-slot="slim-table-cell"
      className={cn(
        'py-1.25 pr-2.5 align-middle text-base font-normal [&:has([role=checkbox])]:pr-0',
        className,
      )}
      {...props}
    />
  );
}

export {
  SlimTable,
  SlimTableBody,
  SlimTableCell,
  SlimTableHead,
  SlimTableHeader,
  SlimTableRow,
};
